// extracted by mini-css-extract-plugin
export var closed = "_bd-1";
export var resizer = "_bd-0";